<template>
  <v-hover v-slot="{ hover }">
    <v-btn
      @click="readyToRecord ? recordStart() : STOP_record()"
      fab
      dark
      small
      :color="readyToRecord ? 'primary' : 'red'"
    >
      <IconsButton :icon="'chat-' + (!isVideo ? 'microphone' : 'video') + (!readyToRecord && hover ? '-off' : '')"/>
      <v-progress-circular
        v-show="mediaRecorderStatus === 'recording'"
        class="ccs"
        :rotate="-90"
        :size="45"
        :width="5"
        :value="(mediaRecorderTimer / maxRecordingTime) * 100"
        color="primary"
      />
    </v-btn>
  </v-hover>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import IconsButton from "components/icons/IconsChat.vue";
export default {
  name: 'BaseRecord',
  components: {IconsButton},
  props: {
    isVideo: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      device: null,
      recorder: null,
      audioFile: null,
    }
  },
  computed: {
    ...mapState('record', ['mediaRecorderStatus', 'mediaRecorderTimer', 'maxRecordingTime']),
    readyToRecord() {
      return this.mediaRecorderStatus === 'inactive'
    },
  },
  methods: {
    ...mapActions('record', ['START_record', 'STOP_record']),
    recordStart() {
      let data = { audio: true }
      if (this.isVideo) {
        data.video = true
      }
      this.START_record(data)
    },
  },
}
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  filter: blur(1px);
}
.ccs {
  position: absolute;
  :deep().v-progress-v-progress-circular__overlay {
    stroke: #9e9e9e66 !important;
  }
}
</style>
